import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../app.component';
import * as $ from 'jquery';
import { OrderPipe } from 'ngx-order-pipe';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss']
})
/** events component*/
export class EventsComponent {
    /** events ctor */
  /** events ctor */
  events: any;
  route: any;
  imgUrl: any;
  title: any;
  itemsPerPage: number;
  Search: any;
  paginationPageNumber: number;
  eventsCount: any;
  eventstitle: any;
  content: any;
  currentDate: any = new Date();
  MenuList: any;
  image: any;
  modeltitle: any;
  fileUrl: any;
  multipleEntry: boolean = false;
  eventSpinner: boolean;
  constructor(private spinner: NgxSpinnerService,private appComponent: AppComponent, private http: HttpClient, private router: Router, private datePipe: DatePipe, private orderpipe: OrderPipe) {
    this.imgUrl = window["orginalImgUrl"];
    this.fileUrl = window["getfile"];
    var str = this.router.url;
    this.route = str.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
  }
  ngOnInit() {
    this.spinner.show();
    this.paginationPageNumber = 1;
    this.itemsPerPage = 6;
    this.getMenuName();
    this.getEvents();
    
  }

  search() {
    this.paginationPageNumber = 1;
  }

  getMenuName() {
    this.http.get(this.appComponent.APIUrl + 'MenuMaster/', {
    }).subscribe((data: any) => {
      this.MenuList = data.menuMasterDTO.filter(x => x.link == this.route);
      this.title = this.MenuList[0].title;
      this.multipleEntry = this.MenuList[0].multipleEntry;
    });
  }
  getEvents() {
    this.eventSpinner = true;
    this.http.get(this.appComponent.APIUrl + 'Post/GetPostByRoute/' + this.route, {
    }).subscribe((data: any) => {
      this.events = data.postDTO.filter(x => x.status == 'Active' && x.displayonhome == 1);
      this.eventsCount = this.events.length;
      this.currentDate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd' + 'T00:00:00');
      this.eventSpinner = false;
    });
  }

  itemPerPagePagination(event: any) {
    this.itemsPerPage = event.target.value;
  }
}
